import React, { Component } from "react";
import { Button, Collapse, Col, Modal, Radio, Row, Well } from "react-bootstrap";
import uniqueId                   from 'lodash/uniqueId';
import DropdownExerciseCategories from "../../components/exercise/DropdownExerciseCategories";
import KeywordsInput              from "../../components/exercise/KeywordsInput";
import LoaderButton               from "../../components/LoaderButton";
import YouTubeThumbnail           from "../../components/YouTubeThumbnail";
import YouTubePlayer              from "../../components/YouTubePlayer";
import ModalYouTubeVideo          from "../../components/modal/ModalYouTubeVideo";
import { Colors }                 from "../../utils/Colors";
import ModalAlert                 from "../../components/modal/ModalAlert";
import ReactQuill, { Quill, Mixin, Toolbar } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import TextAreaMod          from "../../components/TextAreaMod";
import "../../css/exercise/ExerciseNew.css";
import { invokeAddExercise } from "../../utils/AwsInvoke";

var textInput = null;
var submit_label;
var publishNo = false;
var publishYes = false;

const BULLET = '\u2022 ';
const RETURN = '\n';
const CHAR_COUNT = 1500;
const START_TEXT   = BULLET+"Describe the starting position";
const EXECUTE_TEXT = BULLET+"Provide clear and concise instructions on how to perform each step of the exercise";
const FOCUS_TEXT   = BULLET+"Detail what the trainee should concentrate on for safety and best practice";
const GOAL_TEXT    = BULLET+"What is the objective of the exercise?\n  Eg. Core, strength, thoracic mobility, quad strength, etc...";

export default class AddExercisePanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            isLoading: false,
            category_id: 0,
            category_name: "",
            exercise_name: "",
            video_link:    "",
            keywords:   [],
            publish: 0,
            pageOverlay: "",
            showYouTubeModal: false,

            modalAlertTitleText: "",
            modalAlertBodyText:  "",
            showModalAlert:      false, // true | false
            alertObject:         {},
            alertAction:         "",

            startInit: false,
            startFontColor: "#999",
            startTextLgth: 0,
            start:    "",
            executeInit: false,
            executeFontColor: "#999",
            executeTextLgth: 0,
            execute:  "",
            focusInit: false,
            focusFontColor: "#999",
            focusTextLgth: 0,
            focus:    "",
            goalInit: false,
            goalFontColor: "#999",
            goalTextLgth: 0,
            goal:     ""
        };
    }
    componentDidMount() {
        // Scroll to top of page
        window.scrollTo(0, 0);
    }

    handleNameChange  = (event) => {
        var text = event.target.value;
        this.setState({
            exercise_name: text
        });

        this.props.setExerciseName(this.props.ctr, text)
    }

    handleVideoLinkChange  = (event) => {
        var text = event.target.value;

        var newval = '';

        if (newval = text.match(/(\?|&)v=([^&#]+)/)) {
            text = newval.pop();
        } else if (newval = text.match(/(\.be\/)+([^\/]+)/)) {
            text = newval.pop();
        } else if (newval = text.match(/(\embed\/)+([^\/]+)/)) {
            text = newval.pop().replace('?rel=0','');
        }

        this.setState({
            video_link: text
        });

        this.props.setYouTubeId(this.props.ctr, text)
    }

    handleStartChange = (text) => {
        if(text.length < CHAR_COUNT+1) this.setState({ start: text, startTextLgth: text.length});
        this.props.setStartText(this.props.ctr, text)
    }

    handleExecuteChange = (text) => {
        if(text.length < CHAR_COUNT+1) this.setState({ execute: text, executeTextLgth: text.length});
        this.props.setExecuteText(this.props.ctr, text)
    }

    handleFocusChange = (text) => {
        if(text.length < CHAR_COUNT+1) this.setState({ focus: text, focusTextLgth: text.length});
        this.props.setFocusText(this.props.ctr, text)
    }

    handleGoalChange = (text) => {
        if(text.length < CHAR_COUNT+1) this.setState({ goal: text, goalTextLgth: text.length});
        this.props.setGoalText(this.props.ctr, text)
    }

    handlePublish = (event) => {
        //console.log("publish: " + event.target.value);
        var pub = event.target.value;
        if(pub === "Yes") pub = 1; else pub = 0;

        this.setState({
            publish: pub
        })

        this.props.setPubText(this.props.ctr, pub)
    }

    openPanel = (e) => {
        this.setState({ open: !this.state.open })
    }

    getExerciseCategory = (id, category) => {
        this.setState({ category_id: id, category_name: category })
        this.props.setCategoryId(this.props.ctr, id)
    }

    getKeywords = (keywords) => {
        this.setState({
            keywords: keywords
        })
        this.props.setKeywords(this.props.ctr, keywords)
    }


    /*handleSubmit = async event => {
        event.preventDefault();

        var exercise_name = this.state.exercise_name;
        var exercise_id = "new";
        var video_link  = this.state.video_link;
        var start       = "";
        var execute     = "";
        var focus       = "";
        var goal        = "";
        var publish     = this.state.publish;
        var category_id = parseInt(this.state.category_id);
        var keywords    = this.state.keywords;

        if(this.state.startInit) start = this.state.start;
        if(this.state.executeInit) execute = this.state.execute;
        if(this.state.focusInit) focus = this.state.focus;
        if(this.state.goalInit) goal = this.state.goal;

        console.log("---------- Add Exercise Panel Submit ----------");
        console.log("exercise_id: " + exercise_id);
        console.log("exercise_name: " + exercise_name);
        console.log("video_link: " + video_link);
        console.log("category_id: " + category_id);
        console.log("start: " + start);
        console.log("execute: " + execute);
        console.log("focus: " + focus);
        console.log("goal: " + goal);
        console.log("publish: " + publish);

        if(exercise_name === "") {
            var body_text  = "An exercise name is required.";
            this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
        } else {
            this.setState({ isLoading: true });
            try {
                const results = await invokeAddExercise(exercise_id, publish, exercise_name, start, execute, focus, goal, video_link, category_id, keywords);

                if(results.status === true) {
                    this.setState({ isLoading: false });
                    this.goToExerciselist();
                } else
                    alert("Sorry, we had problems adding the exercise. Please try again");

            } catch (e) {
                alert(e);
                this.setState({ isLoading: false });
            }
        }
    }*/

    cancelExercise = () => {
        this.goToExerciselist();
    }

    goToExerciselist = () => {
        this.props.goToExerciselist();
    }

    handleCloseYouTubeWin = () => {
        this.setState({
            showYouTubeModal: false
        });
    }

    showYouTubeModal = (event, yt_id, exercise_name) => {
        this.setState({
            youTubeId: yt_id,
            pageOverlay: "inline",
            showYouTubeModal: true,
            exercise_name: exercise_name
        })
    }

    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }

    render() {

        var vert_10px_spacer = 0;
        var icon_class = "glyphicon glyphicon-menu-down sideNavBarIcon";

        var publishNo  = false;
        var publishYes = false;

        if(this.state.publish == "Yes" || this.state.publish === 1 )
            publishYes = true;
        else
            publishNo = true;

        if(this.state.open) {
            vert_10px_spacer = "10px"
            icon_class = "glyphicon glyphicon-menu-up sideNavBarIcon";
        }

        var openButton = <span>
                            <span style={{position:"relative", left:"0%", float:"left", fontSize:"18px", fontWeight: "bold"}}> </span>
                            <span className={icon_class} style={{ color:"#999", fontWeight:"bold", fontSize: '1.1em' }}/>
                         </span>
        var border_color = "2px solid " + Colors.primary_color;

        let closeModalAlert           = () => this.setState({ showModalAlert: false }); //close alert modal window

        return (<div>
                  <div>
                    <div style={{border: "0px solid #ccc", padding:"7px", backgroundColor:"#efefef", border: "2px solid #ddd", /*borderBottom: "8px solid white"*/ }}>

                                  <div style={{paddingTop:"4px", height:"52px"}}>
                                          <input type="text"
                                                 placeholder = { this.props.ctr + ". Exercise Name"}
                                                 value       = {this.state.exercise_name}
                                                 onChange    = {this.handleNameChange.bind(this)}
                                                 className   = "input-lg tf_addExercise"
                                                 style       = {{width:"100%"}}/>
                                     </div>
                                     <div style={{height:"55px", minWidth: "100%", border: "0px solid black", }}>
                                         <span onClick ={(e) => this.showYouTubeModal(e, this.state.video_link, this.state.exercise_name)}
                                            style={{display:"inline", float:"left", position: "relative", top:"3px", minWidth: "64px", border: "0px solid black"}}>
                                               <YouTubeThumbnail yt_id={this.state.video_link} width={61} /> { }
                                         </span>
                                         <span style={{display:"inline", float:"left", width: "75%", border: "0px solid black"}}>
                                              <input type="text"
                                                     placeholder = "YouTube Link"
                                                     value     = {this.state.video_link}
                                                     onChange  = {this.handleVideoLinkChange.bind(this)}
                                                     className = "input-lg tf_addExercise"
                                                     style     = {{width:"100%", position: "relative", top:"3px"}}/>
                                         </span>
                                  </div>
                                      <div>
                                          <Button style = {{position:"relative", top:"-2px", height:"45px", width:"100%", border: border_color}}
                                                  onClick={() => this.openPanel(this)}>
                                                  { openButton }
                                          </Button>
                                      </div>
                        <div className="iconAddExerciseSmVertSpacer-old" style={{height:vert_10px_spacer}}></div>
                        <span style={{backgroundColor:"red"}}>

                            <Collapse in = {this.state.open} style={{backgroundColor:"white"}}>
                                    <Well>

                                        <Row className="grid">
                                            { /*}<Col xs={6} sm={6} md={6}>
                                                <span className="formLabel">
                                                    YouTube Video Link
                                                </span>
                                            </Col>*/ }
                                              <Col xs={6} sm={6} md={6}>
                                                  <span className="formLabel">
                                                      Assign a Category
                                                  </span>
                                              </Col>
                                        </Row>
                                        <Row className="grid">

                                              <Col xs={6} sm={6} md={6}>
                                                  <span className="formLabel">
                                                      <DropdownExerciseCategories
                                                          id        = {this.state.category_id}
                                                          category  = {this.state.category_name}
                                                          getExerciseCategory={this.getExerciseCategory}

                                                      />
                                                  </span>
                                              </Col>
                                        </Row>
                                        { /********* KEYWORDS *********/ }
                                        <div className="iconAddExerciseVertSpacer"></div>
                                        <Row className="grid">
                                              <Col xs={12} sm={12} md={12}>
                                                  <span className="formLabel">
                                                         Keywords <span className="labelSizeSm">(press return key after every word)</span>
                                                  </span>
                                              </Col>
                                        </Row>
                                        <Row className="grid">
                                              <Col xs={12} sm={12} md={12}>
                                                  <span>
                                                        <KeywordsInput
                                                            tags        = {this.state.keywords}
                                                            getKeywords = {this.getKeywords}
                                                        />
                                                  </span>
                                              </Col>
                                        </Row>
                                        { /********* START *********/ }
                                        <div className="iconAddExerciseVertSpacer"></div>
                                        <Row className="grid">
                                              <Col xs={12} sm={12} md={12}>
                                                  <span className="formLabel">
                                                        1. Start
                                                  </span>
                                              </Col>
                                        </Row>
                                        <Row className="grid">
                                              <Col xs={12} sm={12} md={12}>
                                                  <span style={{textDecoration: "none", backgroundColor:"#fff"}}>
                                                     <TextAreaMod placeholder  = {START_TEXT}
                                                                  value        = {this.state.start}
                                                                  handleChange = {this.handleStartChange.bind(this)}
                                                            />
                                                         { /*} <textarea style={{color:this.state.startFontColor}}
                                                                    rows="5"
                                                                    className = "input-lg ta_addExercise"
                                                                    onFocus   = {this.handleStartChange.bind(this)}
                                                                    onChange  = {this.handleStartChange.bind(this)}
                                                                    value     = {this.state.start}/> */}
                                                  </span>
                                                  <br/><br/>
                                                  <span className="textLabelCounter">Chars remaining: {CHAR_COUNT-this.state.startTextLgth}</span>
                                              </Col>
                                        </Row>

                                        <div className="iconAddExerciseVertSpacer"></div>
                                        <Row className="grid">
                                              <Col xs={12} sm={12} md={12}>
                                                  <span className="formLabel">
                                                        2. Execute
                                                  </span>
                                              </Col>
                                        </Row>
                                        <Row className="grid">
                                              <Col xs={12} sm={12} md={12}>
                                                  <span style={{textDecoration: "none"}}>
                                                      <TextAreaMod placeholder  = {EXECUTE_TEXT}
                                                                   value        = {this.state.execute}
                                                                   handleChange = {this.handleExecuteChange.bind(this)}
                                                           />
                                                          { /*}<textarea style={{color:this.state.executeFontColor}}
                                                                    rows      = "5"
                                                                    className = "input-lg ta_addExercise"
                                                                    onFocus   = {this.handleExecuteChange.bind(this)}
                                                                    onChange  = {this.handleExecuteChange.bind(this)}
                                                                    value     = {this.state.execute}/>*/ }
                                                  </span>
                                                  <br/><br/>
                                                  <span className="textLabelCounter">Chars remaining: {CHAR_COUNT-this.state.executeTextLgth}</span>
                                              </Col>
                                        </Row>

                                        <div className="iconAddExerciseVertSpacer"></div>
                                        <Row className="grid">
                                              <Col xs={12} sm={12} md={12}>
                                                  <span className="formLabel">
                                                        3. Focus
                                                  </span>
                                              </Col>
                                        </Row>
                                        <Row className="grid">
                                              <Col xs={12} sm={12} md={12}>
                                                  <span style={{textDecoration: "none"}}>
                                                      <TextAreaMod placeholder  = {FOCUS_TEXT}
                                                                   value        = {this.state.focus}
                                                                   handleChange = {this.handleFocusChange.bind(this)}
                                                             />
                                                         { /*} <textarea style={{color:this.state.focusFontColor}}
                                                                    rows      = "5"
                                                                    className = "input-lg ta_addExercise"
                                                                    onFocus   = {this.handleFocusChange.bind(this)}
                                                                    onChange  = {this.handleFocusChange.bind(this)}
                                                                    value     = {this.state.focus}/>*/ }
                                                  </span>
                                                  <br/><br/>
                                                  <span className="textLabelCounter">Chars remaining: {CHAR_COUNT-this.state.focusTextLgth}</span>
                                              </Col>
                                        </Row>

                                        <div className="iconAddExerciseVertSpacer"></div>
                                        <Row className="grid">
                                              <Col xs={12} sm={12} md={12}>
                                                  <span className="formLabel">
                                                        4. Goal
                                                  </span>
                                              </Col>
                                        </Row>
                                        <Row className="grid">
                                              <Col xs={12} sm={12} md={12}>
                                                  <span style={{textDecoration: "none"}}>
                                                      <TextAreaMod placeholder  = {GOAL_TEXT}
                                                                   value        = {this.state.goal}
                                                                   handleChange = {this.handleGoalChange.bind(this)}
                                                             />
                                                         { /*} <textarea style={{color:this.state.goalFontColor}}
                                                                    rows      = "5"
                                                                    className = "input-lg ta_addExercise"
                                                                    onFocus   = {this.handleGoalChange.bind(this)}
                                                                    onChange  = {this.handleGoalChange.bind(this)}
                                                                    value     = {this.state.goal}/>*/ }
                                                  </span>
                                                  <br/><br/>
                                                  <span className="textLabelCounter">Chars remaining: {CHAR_COUNT-this.state.goalTextLgth}</span>
                                              </Col>
                                        </Row>

                                        <div className="iconAddExerciseVertSpacer"></div>
                                        { /*}<Row className="grid">
                                              <Col xs={12} sm={12} md={12}>
                                                  <span className="formLabel">

                                                            Submit to TS for Review:<br/>
                                                              <Radio name="radioGroup"
                                                                     inline
                                                                     key = {uniqueId()}
                                                                     checked={publishNo}
                                                                     value = "No"
                                                                     onChange = {this.handlePublish.bind(this)}>
                                                                     No
                                                              </Radio>{' '}
                                                              <Radio name="radioGroup"
                                                                     inline
                                                                     key = {uniqueId()}
                                                                     checked={publishYes}
                                                                     value = "Yes"
                                                                     onChange = {this.handlePublish.bind(this)}>
                                                                Yes
                                                              </Radio>

                                                  </span>
                                              </Col>
                                        </Row>
                                        <div className="iconAddExerciseVertSpacer"></div>

                                        { /*}<Row className="grid">
                                          <Col xs={6} sm={6} md={6}>
                                              <span onClick = { () => this.cancelExercise()}>
                                                  <LoaderButton
                                                    block
                                                    bsSize="large"
                                                    type="button"
                                                    text="Cancel"
                                                  />
                                              </span>
                                            </Col>
                                            <Col xs={6} sm={6} md={6}>
                                                <span onClick = { (e) => this.handleSubmit(e)}>
                                                  <LoaderButton
                                                    block
                                                    bsSize="large"
                                                    style = {{backgroundColor: "#f5cf2f"}}
                                                    //disabled={!this.validateForm()}
                                                    type="submit"
                                                    isLoading={this.state.isLoading}
                                                    text="Submit"
                                                    loadingText="Logging in…"
                                                  />
                                                </span>
                                            </Col>
                                        </Row>*/ }
                                        <Row>
                                            <Button style = {{position:"relative", top:"10px", left:"15px",height:"45px", width:"96%", border: border_color}}
                                                    onClick={() => this.openPanel(this)}>
                                                    { openButton }
                                            </Button>
                                        </Row>
                                    </Well>
                            </Collapse>
                        </span>
                     </div>

                     <div className="iconAddExerciseSmVertSpacer" style={{height:""}}></div>
             </div>

             { /******* MODAL EXERCISE *******/ }
                  <ModalYouTubeVideo
                      pageOverlay      = {this.state.pageOverlay}
                      showYouTubeModal = {this.state.showYouTubeModal}
                      exercise_name    = {this.state.exercise_name}
                      youTubeId        = {this.state.youTubeId}
                      closeYouTubeWin  = {this.handleCloseYouTubeWin}
                      />

                  {this.state.showModalAlert ?
                      <ModalAlert
                          onHide         = {closeModalAlert}
                          alertFunction  = {this.alertFunction}     // custom function to call within modal
                          alertAction    = {this.state.alertAction} // flag used for above function
                          alertObject    = {this.state.alertObject} // vars used for above function
                          showModalAlert = {this.state.showModalAlert}
                          messageTitle   = {this.state.modalAlertTitleText}
                          messageBody    = {this.state.modalAlertBodyText}
                      />
                  : null}
        </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/exercise/AddExercisePanel.js